/* MOL Announcement Bar — rotates messages when collapsed (<1200px). Scoped to [data-mol-announcement].
   Autoplay is on unless data-autoplay="false". Arrows always work for manual stepping. */
(function () {
  var collapse = window.matchMedia('(max-width: 1199.98px)');

  function init(bar) {
    var msgs = bar.querySelectorAll('[data-mol-ab-msg]');
    if (msgs.length < 2) return;

    var prev = bar.querySelector('[data-mol-ab-prev]');
    var next = bar.querySelector('[data-mol-ab-next]');
    var speed = parseInt(bar.dataset.rotate, 10) || 3500;
    var autoplay = bar.dataset.autoplay !== 'false';
    var index = 0;
    var timer = null;

    function show(n) {
      msgs.forEach(function (m, k) { m.classList.toggle('is-active', k === n); });
    }
    function go(step) {
      index = (index + step + msgs.length) % msgs.length;
      show(index);
    }
    function start() { stop(); if (autoplay) timer = setInterval(function () { go(1); }, speed); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if (next) next.addEventListener('click', function () { go(1); start(); });
    if (prev) prev.addEventListener('click', function () { go(-1); start(); });

    function sync() {
      if (collapse.matches) { show(index); start(); } else { stop(); }
    }
    collapse.addEventListener('change', sync);
    sync();
  }

  document.querySelectorAll('[data-mol-announcement]').forEach(init);
}());
